import type { LanguageChoice } from '../../../i18n/languages';

import { ACCOUNT_ENDPOINTS } from './endpoints';
import { LanguageNotSaved } from './errors';
import { request } from './http';
import { languageSavedSchema, parseOrThrow } from './schemas';

export const saveLanguage = async (languagePreference: LanguageChoice, signal: AbortSignal | undefined): Promise<void> => {
  const raw = await request('post', ACCOUNT_ENDPOINTS.UPDATE_LANGUAGE, { body: { languagePreference }, signal });
  const result = parseOrThrow(languageSavedSchema, raw, 'update language');
  if (!result.success) throw new LanguageNotSaved(result.message);
};
